import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FormGroup, Label, Input as InputReact } from 'reactstrap'
import { Select, Input, message, Spin } from 'antd'
import {
    createBrandsRule,
    updateBrandsRule,
    brandsRuleDetails,
    getListBrands,
    getListTagBrand,
} from '../../services/api/apiBrands'
import getHistory from '../../getHistory'
import CheckboxInput from './Components/CheckboxInput'
import { getListSku } from '../../services/api/apiSku'
import './Style/index.scss'
import BrandsRuleHistories from './Components/BrandsRuleHistories'

const { Option } = Select

function BrandsRuleCreatePageContainer(props) {
    const brandRuleId = props.match.params.id
    const [errors, setErrors] = useState({})
    const [searchValue, setSearchValue] = useState('')
    const [isActive, setIsActive] = useState(true)
    const [isNoCard, setIsNoCard] = useState(false)
    const [orderType, setOrderType] = useState(['normal'])
    const [branding, setBranding] = useState([])
    const [packaging, setPackaging] = useState([])
    const [orderIncTags, setOrderIncTags] = useState([])
    const [searchIncTags, setSearchIncTags] = useState('')
    const [orderExcTags, setOrderExcTags] = useState([])
    const [searchExcTags, setSearchExcTags] = useState('')
    const [priority, setPriority] = useState('')
    const [listBrands, setListBrands] = useState([])
    const [brandTags, setBrandTags] = useState([])
    const [loading, setLoading] = useState(false)
    const [brandId, setBrandId] = useState('')
    const [brandName, setBrandName] = useState('')
    const [title, setTitle] = useState([])
    const [searchTitle, setSearchTitle] = useState('')
    const [productType, setProductType] = useState([])
    const [listProductType, setListProductType] = useState([])
    const [listQTY, setListQTY] = useState({})

    const getBrandsRuleDetails = async (id) => {
        setLoading(true)
        try {
            const { data: Data } = await brandsRuleDetails(id)
            const { message: mess, success, data } = Data
            const {
                order_type,
                order_tags: { exc, inc },
                products,
                brand,
                is_active,
                tags,
                priority,
                is_no_card,
                external_product_title,
                tags_quantity_per_item,
            } = { ...data }

            if (success) {
                setOrderType(order_type)
                setOrderIncTags(inc)
                setOrderExcTags(exc)
                setProductType(products)
                setBrandId(brand._id)
                setBrandName(brand.name)
                setIsActive(is_active)
                setIsNoCard(is_no_card)
                setPriority(priority)
                setBranding((!!tags.branding && tags.branding.map(i => i._id)) || [])
                setPackaging((!!tags.packaging && tags.packaging.map(i => i._id)) || [])
                setTitle(external_product_title)
                setListQTY(tags_quantity_per_item)
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }

    }
    const fetchListBrand = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            is_active: true,
        }
        try {
            const { success, message: mess, data } = await getListBrands(payload)
            if (success) {
                setListBrands(data.Brands)
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }
    const fetchListProductType = async () => {

        try {
            const payload = {
                is_active: true,
                limit: 10000,
                page: 1,
                sort: 'sku',
            }
            const { data: { data, success, message: mess } } = await getListSku(payload)
            if (success) {
                setListProductType(data.items)
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }
    const getListBrandTags = async () => {
        setPackaging([])
        setBranding([])
        const payload = {
            page: 1,
            limit: 10000,
            brandName: brandName
        }
        if (brandName) {
            try {
                const { data: { data, success, message: mess } } = await getListTagBrand(payload)
                if (success) {
                    setBrandTags(data.brandTags)
                } else {
                    message.error(mess)
                }
            } catch (error) {
                message.error(error.message)
            }
        }
    }

    useEffect(() => {
        brandName !== '' && getListBrandTags()
    }, [brandName, brandId,])

    useEffect(() => {
        fetchListBrand()
        fetchListProductType()
        !!brandRuleId && getBrandsRuleDetails(brandRuleId)
    }, [])

    const handleSave = () => {
        if (!!brandRuleId) {
            handleUpdateBrandsRule()

        } else {
            handleCreateBrandsRule()
        }
    }

    const handleCreateBrandsRule = async () => {
        if (Validate()) {
            return
        }
        const payload = {
            brand_id: brandId,
            products: productType,
            tags: [...branding, ...packaging],
            order_type: orderType,
            order_inc_tags: orderIncTags,
            order_exc_tags: orderExcTags,
            is_active: isActive,
            is_no_card: isNoCard,
            priority: priority,
            tags_quantity_per_item: listQTY,
        }
        if (title !== '') { payload.external_product_title = title }

        try {
            const { data: Data } = await createBrandsRule(payload)
            const { success, message: mess } = Data
            if (success) {
                message.success('Brands rule đã được tạo!')
                const history = getHistory()
                history.push(`/brands-rule`)
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const handleUpdateBrandsRule = async () => {
        if (Validate()) {
            return
        }
        const payload = {
            brand_id: brandId,
            products: productType,
            tags: [...branding, ...packaging],
            order_type: orderType,
            order_inc_tags: orderIncTags,
            order_exc_tags: orderExcTags,
            is_active: isActive,
            is_no_card: isNoCard,
            priority: priority,
            tags_quantity_per_item: listQTY,
        }
        if (title !== '') { payload.external_product_title = title }

        try {
            const { data: Data } = await updateBrandsRule(brandRuleId, payload)
            const { success, message: mess, } = Data
            if (success) {
                message.success('Brands rule đã đã được update!')
                const history = getHistory()
                history.push(`/brands-rule`)
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const _handleChangeStatus = (value) => {
        if (value === 'Active') {
            setIsActive(true)
        }
        if (value === 'Deactive') {
            setIsActive(false)
        }
    }

    const _handleChangeCard = (value) => {
        if (value === 'Card') {
            setIsNoCard(false)
        }
        if (value === 'NoCard') {
            setIsNoCard(true)
        }
    }

    const handleSearch = (field, value) => {
        if (value.includes(',')) {
            setSearchValue('')
            setSearchIncTags('')
            setSearchExcTags('')
            setSearchTitle('')
            const listSelect = {
                'ProductType': productType,
                'AcceptTag': orderIncTags,
                'ExceptTag': orderExcTags,
                'Title': title,
            }

            const Value = [
                ...listSelect[field],
                ...new Set(value.split(',').map(i => i.trim()).filter(i =>
                    !!i.trim() && !(listSelect[field] || []).includes(i) && i))
            ]
            if (field === 'ProductType') {
                setProductType([...Value])
            }
            if (field === 'AcceptTag') {
                setOrderIncTags([...Value])
            }
            if (field === 'ExceptTag') {
                setOrderExcTags([...Value])
            }
            if (field === 'Title') {
                setTitle([...Value])
            }
        } else {
            if (field === 'ProductType') {
                setSearchValue(value)
            }
            if (field === 'AcceptTag') {
                setSearchIncTags(value)
            }
            if (field === 'ExceptTag') {
                setSearchExcTags(value)
            }
            if (field === 'Title') {
                setSearchTitle(value)
            }
        }
    }

    const _handleChangeMultiSelect = (field, value) => {
        setSearchValue('')
        setSearchIncTags('')
        setSearchExcTags('')
        setSearchTitle('')
        const Value = [... new Set(value.filter(i => !!i && i.trim()).map(i => i.trim()))]
        if (field === 'ProductType') {
            setProductType(Value)
            if (value.includes('All')) {
                setProductType(listProductType.filter(i => i !== ''))
            }
            setErrors({ ...errors, productType: '' })
        }
        if (field === 'AcceptTag') {
            setOrderIncTags(Value)
        }
        if (field === 'ExceptTag') {
            setOrderExcTags(Value)
        }
        if (field === 'Title') {
            setTitle(Value)
        }
    }

    const handleChange = (field, e, value) => {
        if (field === 'Brand') {
            if (!e) {
                setBrandName('')
                setBrandId('')
                setBranding([])
                setPackaging([])
                setBrandTags([])
                setListQTY({})
            } else {
                setBrandId(value)
                setBrandName(e.children)
                setErrors({ ...errors, brands: '' })
                setListQTY({})
            }
        }
        if (field === 'Priority') {
            setPriority(value)
            setErrors({ ...errors, priority: '' })
        }
    }

    const Title = !!brandRuleId ? 'Update brands rule' : 'Add new brands rule'

    const optionOrderType = [
        {
            label: 'Normal order',
            value: "normal"
        },
        {
            label: 'FBA order',
            value: "fba"
        }
    ]
    const optionBranding = brandTags.length && brandTags.filter(i => i.type === "branding").map(i => ({
        label: i.name,
        value: i._id
    })
    )

    const optionPackaging = brandTags.length && brandTags.filter(i => i.type === "packaging").map(i => ({
        label: i.name,
        value: i._id
    })
    )

    const Validate = () => {
        const errorValidate = {}
        const brandRuleTags = [...branding, ...packaging]
        if (priority === '') {
            errorValidate.priority = 'Please input priority!!!'
        }
        if (brandId === '') {
            errorValidate.brands = 'Please choose brands!!!'
        }
        if (!productType.length) {
            errorValidate.productType = 'Please choose product type!!!'
        }
        if (brandId !== '' && (!branding.length && !packaging.length)) {
            errorValidate.brandRule = 'Please choose one brands rule'
        }
        if (brandRuleTags.length > 0) {
            brandRuleTags.forEach((i) => {
                if (i && !listQTY[i]) {
                    errorValidate.listQTY = {
                        ...errorValidate.listQTY,
                        [i]: 'Please input Qty/product!!!'
                    }
                }
            })
        }
        if (!orderType.length) {
            errorValidate.orderType = 'Please choose one order type!!!'
        }
        const checkPriority = !!errorValidate.priority && errorValidate.priority !== ''
        const checkBrands = !!errorValidate.brands && errorValidate.brands !== ''
        const checkProduct = !!errorValidate.productType && errorValidate.productType !== ''
        const checkBrandRule = !!errorValidate.brandRule && errorValidate.brandRule !== ''
        const checkOrderType = !!errorValidate.orderType && errorValidate.orderType !== ''
        const checkListQTY = !!errorValidate.listQTY && Object.keys(errorValidate.listQTY).length > 0
        setErrors(errorValidate)
        if (checkPriority || checkBrands || checkProduct || checkBrandRule || checkOrderType || checkListQTY) {
            return true
        }
        return false
    }

    const disableCard = !packaging.length || packaging.length <= 0

    return (
        <div className='BrandsRuleCreatePageContainer'>
            <div className="ReturnPage mb-2">
                <Link to={'/brands-rule'} className="txt-16">
                    <i className="fa fa-chevron-left mr-1" /> List brands rule
                </Link>
            </div>
            <div className='FileDetailPage'>
                <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                    <h1 className="PageTitle font-weight-bold mb-0">{!loading && Title}</h1>
                    <div className="RightTop">
                        <div className='Actions mb-2'>
                            <Link to={'/brands-rule'}>
                                <button
                                    className='btn btn-secondary mx-1'
                                    style={{ background: '#C4C4C4' }}
                                >
                                    Cancel
                                </button>
                            </Link>
                            <button
                                className='btn btn-primary mx-1'
                                style={{ background: '#4A80F7' }}
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
                <Spin spinning={loading} tip='Data Loading...'>
                    <div className="SectionInner card px-2 py-2 mt-3">
                        <div className='border px-4 py-4 h-100' style={{ width: '65%' }}>
                            <div className=" align-items-center">
                                <div className="mb-3">
                                    <h6 className='font-weight-bold mb-2 txt-14'>Priority <span className='text-danger'>*</span></h6>
                                    <Input
                                        value={priority || ''}
                                        type='number'
                                        className='priority'
                                        placeholder='Priority'
                                        allowClear
                                        onChange={({ target: { value } }) => handleChange('Priority', '', value)}
                                    />
                                    {!!errors.priority &&
                                        <label className='text-danger mt-1 mb-0'>{errors.priority}</label>
                                    }
                                </div>
                                <div className="mb-3">
                                    <h6 className='font-weight-bold mb-2 txt-14'>Brands <span className='text-danger'>*</span></h6>
                                    <Select
                                        className='w-100'
                                        allowClear
                                        value={brandId || []}
                                        showSearch
                                        onChange={(value, e) => handleChange('Brand', e, value)}
                                        filterOption={(input, option) => (
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        )}
                                        placeholder='--- Choose brands ---'
                                    >
                                        {listBrands.length && listBrands.map((i, index) => (
                                            <Option key={index} value={i._id} >{i.name}</Option>
                                        ))}
                                    </Select>
                                    {!!errors.brands &&
                                        <label className='text-danger mt-1 mb-0'>{errors.brands}</label>
                                    }
                                </div>
                                <div className="mb-3">
                                    <h6 className='font-weight-bold mb-2 txt-14'>Product type <span className='text-danger'>*</span></h6>
                                    <div className='align-items-start '>
                                        <Select
                                            mode={'multiple'}
                                            className='Boxes'
                                            onChange={(value) => _handleChangeMultiSelect('ProductType', value)}
                                            style={{ width: '100%' }}
                                            value={productType || []}
                                            onSearch={(value) => handleSearch('ProductType', value)}
                                            searchValue={searchValue || ''}
                                            placeholder='Product type'
                                            options={(listProductType.length && listProductType.map((i) => ({
                                                value: i === '' ? 'All' : i.sku,
                                                lable: i === '' ? 'All' : i.sku
                                            }))) || []}
                                            allowClear
                                        />
                                        {!!errors.productType &&
                                            <label className='text-danger mt-1 mb-0'>{errors.productType}</label>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginBottom: '24px' }}>
                                <div className="BrandsRule mb-3">
                                    <h6 className='font-weight-bold mb-2 txt-14'>Brands rule <span className='text-danger'>*</span></h6>
                                    <CheckboxInput
                                        listCheckBox={optionBranding}
                                        label='Branding'
                                        checkedList={branding}
                                        setCheckedList={setBranding}
                                        setListQTY={setListQTY}
                                        errors={errors}
                                        listQTY={listQTY}
                                    />
                                    <CheckboxInput
                                        listCheckBox={optionPackaging}
                                        label='Packaging'
                                        checkedList={packaging}
                                        setCheckedList={setPackaging}
                                        setListQTY={setListQTY}
                                        errors={errors}
                                        listQTY={listQTY}
                                    />
                                    {!!errors.brandRule &&
                                        <label className='text-danger mb-0'>{errors.brandRule}</label>
                                    }
                                </div>
                                <div className="OrderType mb-3">
                                    <h6 className='font-weight-bold mb-2 txt-14'>Order type <span className='text-danger'>*</span></h6>
                                    <CheckboxInput
                                        listCheckBox={optionOrderType}
                                        label='All'
                                        checkedList={orderType}
                                        setCheckedList={setOrderType}
                                        errors={errors}
                                        listQTY={listQTY}
                                    />
                                    {!!errors.orderType &&
                                        <label className='text-danger mb-0'>{errors.orderType}</label>
                                    }
                                </div>
                                <h6 className='font-weight-bold mb-2 txt-14'>Order tag</h6>
                                <h6>Accept tag</h6>
                                <Select
                                    mode={'tags'}
                                    className='Boxes'
                                    onChange={(value) => _handleChangeMultiSelect('AcceptTag', value)}
                                    style={{ width: '100%' }}
                                    value={orderIncTags || []}
                                    onSearch={(value) => handleSearch('AcceptTag', value)}
                                    searchValue={searchIncTags || ''}
                                    virtual={false}
                                    open={false}
                                    allowClear
                                />
                                <h6>Except tag</h6>
                                <Select
                                    mode={'tags'}
                                    className='Boxes'
                                    onChange={(value) => _handleChangeMultiSelect('ExceptTag', value)}
                                    style={{ width: '100%' }}
                                    value={orderExcTags || []}
                                    onSearch={(value) => handleSearch('ExceptTag', value)}
                                    searchValue={searchExcTags || ''}
                                    virtual={false}
                                    open={false}
                                    allowClear
                                />
                            </div>

                            <div className="mb-3">
                                <h6 className='font-weight-bold mb-2 txt-14'>Product title (Platform)</h6>
                                <Select
                                    mode={'tags'}
                                    className='Boxes'
                                    onChange={(value) => _handleChangeMultiSelect('Title', value)}
                                    style={{ width: '100%' }}
                                    value={title || []}
                                    onSearch={(value) => handleSearch('Title', value)}
                                    searchValue={searchTitle || ''}
                                    virtual={false}
                                    open={false}
                                    allowClear
                                />
                                {!!errors.priority &&
                                    <label className='text-danger mt-1 mb-0'>{errors.title}</label>
                                }
                            </div>

                            <div className="mb-3">
                                <h6 className='font-weight-bold txt-14'>Card</h6>
                                <div className='d-flex align-items-center'>
                                    <FormGroup check className='mr-3 mb-0' disabled={disableCard} >
                                        <Label check className='txt-14'>
                                            <InputReact type="radio" name="Card"
                                                checked={isNoCard === false}
                                                onChange={({ target: { name } }) => _handleChangeCard(name)}
                                                disabled={disableCard}
                                            /> Active
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check disabled={disableCard} >
                                        <Label check className='txt-14'>
                                            <InputReact type="radio" name="NoCard"
                                                checked={isNoCard === true}
                                                onChange={({ target: { name } }) => _handleChangeCard(name)}
                                                disabled={disableCard}
                                            /> Deactive
                                        </Label>
                                    </FormGroup>
                                </div>
                            </div>

                            <h6 className='font-weight-bold txt-14'>Status <span className='text-danger'>*</span></h6>
                            <div className='d-flex align-items-center'>
                                <FormGroup check className='mr-3 mb-0'>
                                    <Label check className='txt-14'>
                                        <InputReact type="radio" name="Active"
                                            checked={isActive === true}
                                            onChange={({ target: { name } }) => _handleChangeStatus(name)}
                                        /> Active
                                    </Label>
                                </FormGroup>
                                <FormGroup check>
                                    <Label check className='txt-14'>
                                        <InputReact type="radio" name="Deactive"
                                            checked={isActive === false}
                                            onChange={({ target: { name } }) => _handleChangeStatus(name)}
                                        /> Deactive
                                    </Label>
                                </FormGroup>
                            </div>
                            {/* <label className='text-danger'>
                                {!!error &&
                                    <label className='text-danger'>{error}</label>
                                }
                            </label> */}
                        </div>
                    </div>
                    <BrandsRuleHistories brandRuleId={brandRuleId} />
                </Spin>
            </div>
        </div>
    )
}

export default BrandsRuleCreatePageContainer
